// import { theme } from "themes/default/theme"
import { tooltipClasses } from "@mui/material/Tooltip"
import { minmaxBreakPoint } from "themes/default/breakpoints"

export const styles = {
  player: (theme) => ({
    width: "100%",
    [`& .rhap_container`]: {
      outline: "none",
      minHeight: {
        sm: 80,
      },
      py: 1,
      px: 2,
      borderRadius: 10,
      background:
        theme.palette.mode === "dark"
          ? `
      linear-gradient(
        to right,
        rgba(22, 146, 177, 1) 0%,
        rgba(13, 83, 100, 1) 100%
      )
      `
          : `linear-gradient(
        to right,
        rgba(52, 211, 192, 1) 0%,
        rgba(22, 146, 177, 1) 100%
      )`,
      [minmaxBreakPoint]: {
        minHeight: 0,
      },
    },
    [`& .rhap_download-progress`]: {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.common.black
          : theme.palette.common.white,
    },
    [`& .rhap_progress-filled`]: {
      backgroundColor: theme.palette.primary.main,
    },
    [`& .rhap_progress-indicator`]: {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
      width: 5,
      height: 20,
      marginLeft: "-1px",
    },
    [`& .rhap_time`]: {
      color:
        theme.palette.mode === "dark"
          ? theme.palette.common.black
          : theme.palette.common.white,
      minWidth: 30,
    },
    [`& .rhap_main-controls-button`]: {
      color:
        theme.palette.mode === "dark"
          ? theme.palette.common.black
          : theme.palette.common.white,
    },
    [`& .rhap_button-clear`]: {
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
    },
    [`& .rhap_horizontal-reverse .rhap_controls-section`]: {
      ml: {
        sm: 3,
      },
      mr: 0,
    },
    [`& .rhap_controls-section`]: {
      flexGrow: 0,
    },
  }),
  controllers: (theme) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.background.default,
      boxShadow: theme.shadows[6],
      borderRadius: 50,
      overflow: "hidden",
      display: "flex",
    },
  }),
  controllerIcon: (theme) => ({
    fontSize: {
      sm: 50,
    },
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
    [minmaxBreakPoint]: {
      fontSize: 25,
    },
  }),
  controllerActionIcon: (theme) => ({
    color: theme.palette.common.black,
    opacity: 0.75,
    fontSize: 25,
  }),
}
